import React, { useState, useEffect } from 'react'
import { useSpring, animated } from '@react-spring/web'

interface AnimationFadeProps {
  children?: React.ReactNode;
}

export const AnimationFade: React.FC<AnimationFadeProps> = ({ children }) => {
  const [show, setShow] = useState(false)

  const props = useSpring({ opacity: show ? 1 : 0, config: { duration: 300 } })
  useEffect(() => {
    setShow(true)
  }, [])

  return (
    <animated.div style={props}>
      {children}
    </animated.div>
  )
}
